import { Checklist, CreateChecklistDto, UpdateChecklistDto } from '../generated-types/checklist-types'
import { useGet, usePost, usePut, useDelete } from './reactQuery'

const checklistUrl = (customerId: number) => `customers/${customerId}/checklists`

export const useGetChecklists = (customerId: number) =>
    useGet<Checklist[]>(checklistUrl(customerId), undefined, { enabled: !!customerId })

export const useGetChecklistById = (customerId: number, id: number) =>
    useGet<Checklist>(`${checklistUrl(customerId)}/${id}`, undefined, { enabled: !!customerId && !!id })

export const useCreateChecklist = (customerId: number) =>
    usePost<Checklist, CreateChecklistDto>(checklistUrl(customerId))

export const useUpdateChecklist = (customerId: number, id: number) =>
    usePut<Checklist, UpdateChecklistDto>(`${checklistUrl(customerId)}/${id}`)

export const useDeleteChecklist = (customerId: number) =>
    useDelete<Checklist>(checklistUrl(customerId))
